import { render, staticRenderFns } from "./tripartiteRecruitDetail.vue?vue&type=template&id=cb45269c&scoped=true&"
import script from "./tripartiteRecruitDetail.vue?vue&type=script&lang=js&"
export * from "./tripartiteRecruitDetail.vue?vue&type=script&lang=js&"
import style0 from "./tripartiteRecruitDetail.vue?vue&type=style&index=0&id=cb45269c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb45269c",
  null
  
)

export default component.exports